var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-default",class:_vm.btnClass,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text)+" "),(_vm.need_forward)?_c('img',{staticClass:"forward",attrs:{"src":require("../assets/icn_forward.svg"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }